import authReducer from "./authReducer";
import professorReducer from "./professorReducer";

import companyReducer from "./companyReducer";
import usersReducer from "./usersReducer";
import mastermindReducer from "./mastermindReducer";
import rolesReducer from "./rolesReducer";

import { firestoreReducer } from "redux-firestore";
import { firebaseReducer } from "react-redux-firebase";

import { combineReducers } from "redux";
import contractReducer from "./contractReducer";

const appReducer = combineReducers({
	auth: authReducer,
	professors: professorReducer,
	company: companyReducer,
	contracts: contractReducer,
	mastermind: mastermindReducer,
	users: usersReducer,
	firestore: firestoreReducer,
	firebase: firebaseReducer,
	roles: rolesReducer,
});

const rootReducer = (state, action) => {
	let newState = appReducer(state, action);

	// IMPERSONATION LOGIC: If a surrogate UID is set in session, override the auth UID globally.
	// This makes all Firestore queries and components "think" they are the surrogate user.
	try {
		const surrogateId = sessionStorage.getItem('surrogate_uid');
		if (surrogateId && newState.firebase?.auth?.uid) {
			// Verification: Only allow if the base profile is an admin (or we are already impersonating as an admin)
			const isAdmin = newState.firebase.profile?.role?.includes('admin') || newState.firebase.profile?.realRole?.includes('admin');
			if (isAdmin) {
				const surrogateProfileStr = sessionStorage.getItem('surrogate_profile');
				let surrogateProfile = null;
				try {
					if (surrogateProfileStr) surrogateProfile = JSON.parse(surrogateProfileStr);
				} catch (e) { }

				newState = {
					...newState,
					firebase: {
						...newState.firebase,
						profile: surrogateProfile ? {
							...surrogateProfile,
							isImpersonating: true,
							realRole: newState.firebase.profile.role
						} : newState.firebase.profile,
						auth: {
							...newState.firebase.auth,
							uid: surrogateId,
							email: surrogateProfile?.email || newState.firebase.auth.email,
							displayName: surrogateProfile ? `${surrogateProfile.firstname} ${surrogateProfile.lastname}` : newState.firebase.auth.displayName,
							photoURL: surrogateProfile?.avatarUrl || surrogateProfile?.photoUrl || newState.firebase.auth.photoURL,
							isImpersonating: true,
							realUid: newState.firebase.auth.uid,
							realEmail: newState.firebase.auth.email
						}
					}
				};
			}
		}
	} catch (e) {
		console.error("Impersonation Reducer Error:", e);
	}

	return newState;
};

export default rootReducer;
